import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { IconsService } from './services/icons.service';

@Component( {
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
} )
export class AppComponent {
  title = 'Flowhawk';

  constructor(
    private iconsService: IconsService,
  ) { }

  ngOnInit() {
    this.iconsService.registerIcons();
    console.log( 'Build number: ' + environment.buildNumber );
  }
}
